module.exports = __webpack_public_path__ + "static/media/gamfi.04ab614f.png";